/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Url_InvalidInputs */

const cs_ebr_url_invalid = /** @type {(inputs: Ebr_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte https adresu exportu eBrány.`)
};

const en_ebr_url_invalid = /** @type {(inputs: Ebr_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an https eBrána export URL.`)
};

/**
* | output |
* | --- |
* | "Enter an https eBrána export URL." |
*
* @param {Ebr_Url_InvalidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_url_invalid = /** @type {((inputs?: Ebr_Url_InvalidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Url_InvalidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_url_invalid(inputs)
	return cs_ebr_url_invalid(inputs)
});